import { Button } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { ChevronLeftIcon } from 'lucide-react';
import {
  FormContentContainer,
  FormFooterContainer,
  FormMainContainer,
} from '@duke-hq/ui/components/Modals/FormModalLayouts';
import { CsvSubmissionSummary } from '@duke-hq/csv-parser/components/CsvSubmissionSummary';
import { useBulkInternalEnrolments } from '@duke-hq/app-provider-web/tenant/components/BulkEnrolments/useBulkInternalEnrolments';
import { TeamSummaryErrorTable } from '@duke-hq/app-provider-web/tenant/Team/TeamSummaryErrorTable';

export function SkillSetSummary({ goToPrevStep }: { goToPrevStep: () => void }) {
  const {
    csvErrors,
    csvSuccess,
    closeModal,
    state: { selectedCourseAttributes },
  } = useBulkInternalEnrolments();

  const courseType =
    selectedCourseAttributes?.kind === 'QUALIFICATION' ? t`Qualification` : t`Skill Set`;
  return (
    <FormMainContainer>
      <FormContentContainer>
        <CsvSubmissionSummary
          successCount={csvSuccess.length ?? 0}
          errorCount={csvErrors.length ?? 0}
          entityLabel={courseType}
          errorTable={
            <TeamSummaryErrorTable
              errors={csvErrors.map((err) => ({
                firstName: err.firstName ?? '',
                lastName: err.lastName ?? '',
                email: err.email ?? '',
                reason: err.reason ?? '',
              }))}
            />
          }
        />
      </FormContentContainer>

      <FormFooterContainer>
        <Button onClick={closeModal}>
          <Trans>Close</Trans>
        </Button>
        <Button onClick={goToPrevStep} variant="tertiary" leftIcon={<ChevronLeftIcon />}>
          <Trans>Back</Trans>
        </Button>
      </FormFooterContainer>
    </FormMainContainer>
  );
}
